import { Card, CardBody, Col, Form, FormGroup, Input, Label } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CheckMeOut, EmailAddress, EmailFloatingPlaceholder, FloatingPasswordPlaceholder, FormFloating, PasswordFloatingPlaceholder, SignInButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import { FLOATING_FORM } from "../../../../Data/FormControl/BaseInput";

const FloatingForm = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FormFloating} span={FLOATING_FORM} />
        <CardBody>
          <div className="card-wrapper border rounded-3">
            <Form className="row g-3 floating-wrapper" onSubmit={(e)=>e.preventDefault()}>
              <Col sm="12">
                <FormGroup  floating className="mb-3">
                  <Input type="email" placeholder={EmailFloatingPlaceholder} />
                  <Label check>{EmailAddress}</Label>
                </FormGroup>
              </Col>
              <Col sm="12" className="mt-2">
                <FormGroup floating>
                  <Input type="password" autoComplete="" placeholder={PasswordFloatingPlaceholder} />
                  <Label check>{FloatingPasswordPlaceholder}</Label>
                </FormGroup>
              </Col>
              <Col sm="12" className="mt-0">
                <div className="form-check checkbox-checked">
                  <Input id="gridCheck" type="checkbox" />
                  <Label htmlFor="gridCheck" check>{CheckMeOut}</Label>
                </div>
              </Col>
              <Col sm="12">
                <Btn color="primary">{SignInButton}</Btn>
              </Col>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default FloatingForm;
